module.exports = __webpack_public_path__ + "img/full3-min.55ac3228.png";